/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdBackTopProps } from './type';

export const backTopDefaultProps: TdBackTopProps = {
  container: 'body',
  duration: 200,
  offset: ['24px', '80px'],
  shape: 'square',
  size: 'medium',
  target: 'body',
  theme: 'light',
  visibleHeight: '200px',
};
